"use client";

import React from "react";

import Image from "next/image";

interface ErrorBannerProps {
  message: string;
  onDismiss: () => void;
  className?: string;
}

const ErrorBanner = ({ message, onDismiss, className = "" }: ErrorBannerProps) => {
  return (
    <div
      className={`border-error-50 bg-background-error shadow-hard-5 mx-auto mb-14.5 flex w-full max-w-97.5 items-center justify-between rounded-xl border p-4 ${className}`}>
      <div className="flex items-center">
        <div className="flex items-center justify-center rounded-full p-0.25">
          <Image src="/images/invalid.svg" height={16} width={16} alt="error" />
        </div>
        <span className="text-body-normal/md text-error-500 ml-3">{message}</span>
      </div>
      <button onClick={onDismiss} className="text-error-500 hover:text-error-700" type="button">
        <span className="text-lg">&times;</span>
      </button>
    </div>
  );
};

export default ErrorBanner;
